@import '../../../globals/main.scss';

$check-timing: 180ms;
$bg-timing: 220ms;
$easing: cubic-bezier(0.79, 0.14, 0.15, 0.86);

pn-choice-button {
  user-select: none;
  border: none;
  display: inline-block;
  background: #fff;
  position: relative;
  margin: 0.2em 0.4em;

  input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    margin: 0;
    width: 100%;
    height: 100%;
  }

  label {
    display: flex;
    align-items: center;
    padding: 0.4rem 0.8rem;
    border: 0.1rem solid $gray200;
    color: $blue700;
    font-weight: 500;
    border-radius: 0.8rem;
    text-align: center;
    cursor: pointer;
    transition:
      box-shadow 0.1s,
      background 0.2s;

    pn-illustration {
      display: inline-block;
      width: 3rem;
      height: 3rem;
      margin-right: 0.9rem;
    }
  }
}

pn-choice-button > input {
  &:checked + label.pn-choice-button {
    background: $blue50;
    color: $blue700;
    border-color: $blue700;
    box-shadow:
      0px 0.6px 1.8px rgba(0, 0, 0, 0.1),
      0px 3.2px 7.2px rgba(0, 0, 0, 0.13);
  }
  &:indeterminate + label.pn-choice-button {
    background: $white;
    color: $blue700;
  }

  &:hover + label.pn-choice-button {
    background: $blue50;
  }

  &:focus + label.pn-choice-button,
  &:active + label.pn-choice-button {
    box-shadow:
      0 0 0 0.2rem #fff,
      0 0 0 0.4rem $blue700;
  }

  &:active + label.pn-choice-button {
    background: $blue200;
  }

  &:disabled + label.pn-choice-button {
    background-color: $gray200;
  }

  &:checked + label.pn-choice-button:hover {
    background: $blue200;
  }

  &:checked + label.pn-choice-button:active {
    background: $blue200;
    border: 0.1rem solid $blue400;
  }
}
